<template>
  <object
    scroll="no"
    style="width: 100%; height: 100vh; overflow-x: hidden !important"
    scrolling="no"
    type="text/html"
    data="https://app.powerbi.com/view?r=eyJrIjoiYzhhZWQ3MzAtNDEzMi00ODcyLWE3NDUtMDg4MzY3ZjJlYmZmIiwidCI6IjgyNDdiNDNkLTZiOGItNDM5OS1iNWM4LTAzZjU3Zjk5MGE2MCIsImMiOjR9"
  ></object>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Comdac",
  data() {
    return {};
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {
    if (!this.permissions.includes("COMDAC")) this.$router.push("/dashboard");
  },
};
</script>

<style>
</style>
